/**
 * Dashboard Sidebar Toggle
 *
 * 響應式 sidebar：
 * - 桌面 (lg+)：永遠展開 w-48
 * - 手機 (< lg)：隱藏，hamburger 點擊以 overlay 展開
 */

function initSidebarToggle() {
  const sidebar = document.querySelector('.dashboard-sidebar');
  if (!sidebar) return;

  const hamburger = document.querySelector('[data-sidebar-hamburger]');
  const backdrop = document.querySelector('[data-sidebar-backdrop]');
  if (!hamburger || !backdrop) return;

  // Hamburger click → expand as overlay
  hamburger.addEventListener('click', () => {
    sidebar.classList.remove('w-0', 'overflow-hidden');
    sidebar.classList.add('fixed', 'left-0', 'top-0', 'bottom-0', 'w-48', 'z-40', 'shadow-lg', 'overflow-y-auto');
    backdrop.classList.remove('hidden');
    hamburger.classList.add('hidden');
  });

  // Backdrop click → collapse
  backdrop.addEventListener('click', () => {
    closeOverlay(sidebar, hamburger, backdrop);
  });

  // Escape key closes overlay
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar.classList.contains('fixed')) {
      closeOverlay(sidebar, hamburger, backdrop);
    }
  });
}

function closeOverlay(sidebar, hamburger, backdrop) {
  sidebar.classList.remove('fixed', 'left-0', 'top-0', 'bottom-0', 'z-40', 'shadow-lg', 'w-48', 'overflow-y-auto');
  sidebar.classList.add('w-0', 'overflow-hidden');
  backdrop.classList.add('hidden');
  hamburger.classList.remove('hidden');
}

document.addEventListener('DOMContentLoaded', initSidebarToggle);
